import React, { useState, useEffect } from 'react';
import './ConfirmDeleteModal.css';

interface ConfirmDeleteModalProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  confirmLabel?: string;
  /** If set, user must type this exact phrase to enable confirm */
  requiredPhrase?: string;
  danger?: boolean;
  loading?: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  title,
  description,
  confirmLabel = 'Delete',
  requiredPhrase,
  danger = true,
  loading = false,
  error,
  onCancel,
  onConfirm,
}) => {
  const [phrase, setPhrase] = useState('');

  useEffect(() => {
    if (open) setPhrase('');
  }, [open]);

  if (!open) return null;

  const canConfirm = requiredPhrase
    ? phrase.trim() === requiredPhrase
    : true;

  return (
    <div className="confirm-modal-backdrop" role="presentation" onClick={onCancel}>
      <div
        className={`confirm-modal${danger ? ' confirm-modal-danger' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="confirm-modal-title">{title}</h3>
        <div className="confirm-modal-body">{description}</div>

        {requiredPhrase && (
          <div className="confirm-modal-phrase">
            <label htmlFor="confirm-phrase">
              Type <strong>{requiredPhrase}</strong> to confirm
            </label>
            <input
              id="confirm-phrase"
              type="text"
              value={phrase}
              onChange={(e) => setPhrase(e.target.value)}
              autoComplete="off"
              disabled={loading}
            />
          </div>
        )}

        {error && <div className="confirm-modal-error">{error}</div>}

        <div className="confirm-modal-actions">
          <button
            type="button"
            className="dash-btn dash-btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`dash-btn ${danger ? 'dash-btn-danger' : 'dash-btn-primary'}`}
            onClick={onConfirm}
            disabled={!canConfirm || loading}
          >
            {loading ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
